import {NgComponentOutlet} from '@angular/common';
import {Component, effect, inject, signal, Type} from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {ThemeService} from './new/services/theme.service';
import {MaintenanceStateService} from './new/services/maintenance-state.service';
import {ChunkLoadingService, wrapChunkLoad} from './new/services/chunk-loading.service';
import {ZardLoaderComponent} from './new/components/ui-components/loader/loader.component';

@Component({
    selector: 'app-root',
    imports: [RouterOutlet, NgComponentOutlet, ZardLoaderComponent],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss'
})
export class AppComponent {
  private readonly themeService = inject(ThemeService);
  protected readonly maintenanceState = inject(MaintenanceStateService);
  /** Ensures the root chunk-loading overlay is available for route + dialog loads. */
  protected readonly chunkLoading = inject(ChunkLoadingService);
  protected readonly maintenanceScreen = signal<Type<unknown> | null>(null);

  constructor(
    translator: TranslateService
  ) {
    translator.setDefaultLang('de');
    translator.use('de');
    this.themeService.initializeTheme();

    effect(() => {
      if (this.maintenanceState.blockingMaintenanceActive()) {
        void wrapChunkLoad(
          import('./new/components/shared/maintenance-screen/maintenance-screen.component'),
        ).then((module) => this.maintenanceScreen.set(module.MaintenanceScreenComponent));
      } else {
        this.maintenanceScreen.set(null);
      }
    });
  }
}
